import { render, staticRenderFns } from "./EmployeeOfficialHolidaysPlans.vue?vue&type=template&id=462e8670&"
import script from "./EmployeeOfficialHolidaysPlans.vue?vue&type=script&lang=js&"
export * from "./EmployeeOfficialHolidaysPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports